import './SupportModal.css'
import type { BusinessAppSummary } from '../../api/businessApps'

/** Randurile din checklist care se completeaza in fereastra de suport. */
const SUPPORT_KEYS = ['support', 'schedule', 'escalation']

/** Ce lipseste din suport, in cuvintele scurte ale celulei. */
const SHORT: Record<string, string> = {
  support: 'contract',
  schedule: 'hours',
  escalation: 'contacts',
}

/**
 * Celula SUPPORT din lista aplicatiilor: furnizorul + cati oameni are, si ce
 * mai lipseste. Cu drept de editare (`onEdit`), celula e un buton care
 * deschide fereastra "Support - <aplicatie>"; fara drept, doar se citeste.
 */
export function SupportCell({ app, onEdit }: { app: BusinessAppSummary; onEdit?: (id: number) => void }) {
  const missing = (app.missing ?? []).filter((m) => SUPPORT_KEYS.includes(m.key))
  const contacts = app.contactCount > 0 ? `${app.contactCount} contact${app.contactCount === 1 ? '' : 's'}` : 'no contacts'
  const gap = missing.map((m) => SHORT[m.key]).join(', ')
  const gapTitle = missing.map((m) => m.label).join('; ')

  if (app.supportVendor === '') {
    if (!onEdit) return <span className="adm-muted">not filled in</span>
    return (
      <button type="button" className="btn btn-xs btn-default app-sup-add" onClick={() => onEdit(app.id)} title="Who supports this application, when, and whom to call">
        <i className="fas fa-plus"></i> Add support
      </button>
    )
  }

  const body = (
    <>
      {app.supportVendor}
      <span className="adm-muted"> · {contacts}</span>
      {missing.length > 0 ? (
        <span className="app-sup-gap" title={`Still missing: ${gapTitle}`}>
          {' '}
          <i className="fas fa-exclamation-circle"></i> no {gap}
        </span>
      ) : null}
    </>
  )

  if (!onEdit) return <span className="app-sup-cell">{body}</span>
  return (
    <button type="button" className="btn btn-link app-sup-cell app-sup-edit" onClick={() => onEdit(app.id)} title="Edit the support details">
      {body} <i className="fas fa-pencil-alt app-sup-pen"></i>
    </button>
  )
}
